<template>
  <div>
    <b-button
      v-permission="'influencer_groups.create'"
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      variant="primary"
      @click="addNew">
      <feather-icon icon="PlusIcon" class="mr-50"/>
      <span class="align-middle">{{ $t('AddNew') }}</span>
    </b-button>

    <Grid :service="service" route_name="influencer_groups" order_column="name">
      <template v-slot:gridThead>
        <vs-th key="id" sort-key="id">ID</vs-th>
        <vs-th key="name" sort-key="name">{{ $t('influencer_group.name') }}</vs-th>
        <vs-th key="description">{{ $t('influencer_group.description') }}</vs-th>
        <vs-th key="members">{{ $t('influencer_group.members') }}</vs-th>
        <vs-th key="status" sort-key="status">{{ $t('influencer_group.status') }}</vs-th>
      </template>
      <template v-slot:gridData="props">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in props.data">
          <vs-td width="5%" key="id">{{ tr.id }}</vs-td>
          <vs-td width="30%" key="name">{{ tr.name }}</vs-td>
          <vs-td width="35%" key="description"><small class="text-muted">{{ tr.description }}</small></vs-td>
          <vs-td width="10%" key="members">{{ tr.members_count }}</vs-td>
          <vs-td width="10%" key="status">
            <vs-chip transparent :color="tr.status === 'AC' ? 'success' : 'warning'">
              {{ tr.status === 'AC' ? $t('active') : $t('inactive') }}
            </vs-chip>
          </vs-td>
          <vs-td width="10%">
            <div class="flex flex-row gap-2">
              <feather-icon
                v-permission="'influencer_groups.edit'"
                icon="EditIcon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-warning"
                @click="props.edit(props.data[indextr].id)"/>
              <feather-icon
                v-permission="'influencer_groups.delete'"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
                @click="props.destroy(props.data[indextr])"/>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </Grid>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import InfluencerGroupService from '@/services/api/InfluencerGroupService'

export default {
  directives: { Ripple },
  components: { BButton },
  data: () => ({ service: null }),
  methods: {
    addNew() {
      this.$router.push('/influencer_groups/create')
    }
  },
  beforeMount() {
    this.service = InfluencerGroupService.build(this.$vs)
  }
}
</script>
